export class DialogResult<T = any> {

  state: DialogResultState;

  data?: T;

  constructor(state: DialogResultState, data?: T) {
    this.state = state;
    this.data = data;
  }

  public isOk(): boolean {
    return this.state != DialogResultState.CANCEL;
  }
}

export enum DialogResultState {
  CANCEL = 'cancel',
  OK = 'ok',
  CREATE = 'create',
  UPDATE = 'update'
}
